import { useEffect, useState } from "react";

type Listener = (message: string) => void;
let listeners: Listener[] = [];

export function showToast(message: string) {
  listeners.forEach((l) => l(message));
}

export function ToastHost() {
  const [message, setMessage] = useState("");
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    const handler: Listener = (msg) => {
      setMessage(msg);
      setNonce((n) => n + 1);
    };
    listeners.push(handler);
    return () => {
      listeners = listeners.filter((l) => l !== handler);
    };
  }, []);

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (nonce === 0) return;
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 2200);
    return () => clearTimeout(t);
  }, [nonce]);

  return (
    <div className="fixed inset-x-0 bottom-8 z-[100] flex justify-center pointer-events-none px-4">
      {visible && message && (
        <div className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-secondary-900 text-background-50 text-sm animate-fade-up">
          <span className="w-5 h-5 flex items-center justify-center text-primary-300">
            <i className="ri-checkbox-circle-line"></i>
          </span>
          {message}
        </div>
      )}
    </div>
  );
}